"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATIONS_BY_SPORT = exports.TENNIS_ORGANIZATIONS = void 0;
exports.TENNIS_ORGANIZATIONS = [
    'Grand Slam',
    'Teams',
    'ATP',
    'WTA',
    'ATP Challenger Series',
    'ITF Men',
    'ITF Women',
    'Exhibition matches',
];
exports.ORGANIZATIONS_BY_SPORT = {
    tennis: exports.TENNIS_ORGANIZATIONS,
};
//# sourceMappingURL=sportOrganizations.js.map